class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
      console.log(454)
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    //alert(2)
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? "clear" : "change";

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(
          `${eventTarget}:paint-updated-sections"`,
          () => {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`);
            const items = document.querySelectorAll(".cart-item");

            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute("value");
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }

            this.classList.toggle("is-empty", parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter)
              cartFooter.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
            const updatedValue = parsedState.items[line - 1]
              ? parsedState.items[line - 1].quantity
              : undefined;
            let message = "";
            if (
              items.length === parsedState.items.length &&
              updatedValue !== parseInt(quantityElement.value)
            ) {
              if (typeof updatedValue === "undefined") {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace(
                  "[quantity]",
                  updatedValue
                );
              }
            }
            this.updateLiveRegions(line, message);

            const lineItem =
              document.getElementById(`CartItem-${line}`) ||
              document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(
                    cartDrawerWrapper,
                    lineItem.querySelector(`[name="${name}"]`)
                  )
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(
                cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                cartDrawerWrapper.querySelector("a")
              );
            } else if (
              document.querySelector(".cart-item") &&
              cartDrawerWrapper
            ) {
              trapFocus(
                cartDrawerWrapper,
                document.querySelector(".cart-item__name")
              );
            }
          }
        );

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
//     setTimeout(function () {
//        var getProductitle = $('.small-box-bundle-section').attr('data-attr')
// $('.subscription-box-item .subscription-box-title').text(getProductitle)

//     var urlParams = new URLSearchParams(window.location.search);

//     if (urlParams.has('frequency')) {
//         var frequencyValue = urlParams.get('frequency');

//         if (frequencyValue === 'one-time') {
//             // Show custom checkout button
//             $('button.button.custom_checkout-button').show();
//             $('button#CartDrawer-Checkout').hide();
//             $('a.button.custom_checkout-button').css('display','inline-flex');
//             $('.cart__checkout-button').hide();
//         } else {
//             // Show default checkout button
//             $('button#CartDrawer-Checkout').show();
//             $('button.button.custom_checkout-button').hide();
//             $('a.button.custom_checkout-button').hide();
//             $('.cart__checkout-button').show();
//         }
//     } else {
//         $('button#CartDrawer-Checkout').show();
//         $('button.button.custom_checkout-button').hide();
//         $('a.button.custom_checkout-button').hide();
//         $('.cart__checkout-button').show();
//     }

// $.getJSON("/cart.js").done(function (cart) {
//   var totalPrice = cart.total_price;
//   var totalPriceFormatted = (totalPrice / 100).toFixed(2);
// $('.totals__total-value-cart').text('$'+totalPriceFormatted+' USD')
//    if (cart.item_count > 1) {
//         $("ul.chnages--plan-button").show();
//          $(".subscription-box-item").show();
//         }else{
//            $("ul.chnages--plan-button").hide();
//             $(".subscription-box-item").hide();
//         }
//     var hasSubscription = false;
//     cart.items.forEach(function (item) {
//         if (item.selling_plan_allocation) {
//             hasSubscription = true;
//         }
//     });
//     if (hasSubscription) {
//         $('a.button.custom_checkout-button').hide();
//         $("button#CartDrawer-Checkout").show();
//     } else {
//         $('a.button.custom_checkout-button').css('display', 'inline-flex');
//         $("button#CartDrawer-Checkout").hide();
//     }

//     updateFreeGiftProgressBar(cart.items.reduce((total, item) => total + item.quantity, 0));

//     function refreshDrawerAndBubble(count) {
//         $("body").removeClass("free-product-adding");
//         refreshCartDrawer();
//         $('.cart-count-bubble span[aria-hidden="true"]').text(count);
//     }

//     function updateFreeGiftProgressBar(itemCount) {
//         var barMessage = $('body').attr('data-bar-message');
//         var successMessage = $('body').attr('data-sucess-message');

//         const progressBarFill = document.querySelector(".free-gift-progress-bar-fill");
//         const messageBox = document.querySelector(".free-gift-progress-message");

//         if (!progressBarFill || !messageBox) return;

//         const goal = 10;
//         const percent = Math.min((itemCount / goal) * 100, 100);
//         progressBarFill.style.width = `${percent}%`;

//         if (itemCount >= goal) {
//             messageBox.innerHTML = successMessage;
//             progressBarFill.style.backgroundColor = "#28a745"; // Success Green
//         } else {
//             const remaining = goal - itemCount;
//             let dynamicMessage = barMessage
//                 .replace('[[remaining]]', `<strong>${remaining}</strong>`)
//                 .replace('[[itemLabel]]', remaining > 1 ? 'items' : 'item');
//             messageBox.innerHTML = dynamicMessage;
//             progressBarFill.style.backgroundColor = "#28a745";
//         }
//     }

//     $.getJSON("/cart.js").done(function (cart) {
//         if (cart.attributes && cart.attributes.selected_pack) {
//     var selectedPack = cart.attributes.selected_pack;
//     console.log('Selected Pack:', selectedPack);
//     $('.subscription-box-item .subscription-box-title').text(selectedPack)
//   }
//         let totalCount = 0;
//         let cartTotal = 0;

//         cart.items.forEach(function (item) {
//             totalCount += item.quantity;
//             cartTotal += (item.price * item.quantity);
//         });

//         // Convert cartTotal from cents to dollars
//         cartTotal = cartTotal / 100;

//         if ($('body').hasClass('product')) {
//             if (totalCount >= 5 || cartTotal > 90) {
//                 $("button#CartDrawer-Checkout").removeAttr("disabled", "disabled");
//                 $("button#checkout").removeAttr("disabled", "disabled");
//                 $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').show();
//                 $('a.button.custom_checkout-button').removeAttr("disabled", "disabled");
//                 //$('.cart-error-message-five-qty').hide();
//             } else {
//                 $('a.button.custom_checkout-button').attr("disabled", "disabled");
//                 $('.cart__dynamic-checkout-buttons.additional-checkout-buttons').hide();
//                 $("button#CartDrawer-Checkout").attr("disabled", "disabled");
//                 $("button#checkout").attr("disabled", "disabled");
//                // $('.cart-error-message-five-qty').show();
//             }
// // Small-box logic
// let boxTitle = $('.subscription-box-header .subscription-box-title').text().trim().toLowerCase(); // small / large
// let maxLimit = 0;

// if (boxTitle.includes('signature') || boxTitle.includes('small')) {
//   maxLimit = 7;
//   // Hide the large box error
//   $('.checkout--error-msg-new').hide();
// } else if (boxTitle.includes('large')) {
//   maxLimit = 11;
//   // Hide the small box error
//   $('.checkout--error-msg').hide();
// }

// let current = cart.item_count;

// // Select proper error message container based on box type
// let errorContainer = maxLimit === 7 ? $('.checkout--error-msg') : $('.checkout--error-msg-new');

// // Logic for cart item limits
// if (current > maxLimit) {
//   let extra = current - maxLimit;
//   $('button.cart__checkout-button.button').attr('disabled', 'disabled');
//   $('a.button.custom_checkout-button').attr('disabled', 'disabled');
//   errorContainer.find('.extra-items-1').text(extra);
// errorContainer.text(`Please remove ${extra} item(s).`).show();

// } else if (current < maxLimit) {
//   let remaining = maxLimit - current;
//   $('button.cart__checkout-button.button').attr('disabled', 'disabled');
//   $('a.button.custom_checkout-button').attr('disabled', 'disabled');
//   errorContainer.find('.extra-items-1').text(remaining);
//   errorContainer.text(`Add ${remaining} more item(s) to ${boxTitle.charAt(0).toUpperCase() + boxTitle.slice(1)}.`).show();
// } else {
//   // exactly at limit
//   $('button.cart__checkout-button.button').removeAttr('disabled');
//   $('a.button.custom_checkout-button').removeAttr('disabled');
//   errorContainer.hide();
// }







//         }
//     });
// });

// }, 2000);


    //     setTimeout(function () {

    //       $.getJSON("/cart.js").done(function (cart) {
    //         const cartCount = cart.item_count;
    //         const isSmallBox = $("body").hasClass("small-box");
    //         const isLargeBox = $("body").hasClass("large-box");

    //         /* ---------- REMOVE LOGIC ---------- */
    //         if ((isSmallBox && cartCount < 6) || (isLargeBox && cartCount < 11)) {
    //           const $freeRow = $('tr.cart-item[data-variant-name="Free Offer"]');
    //           const variantId = parseInt($freeRow.data("variant-id"), 10);
    //           if (variantId) removeItem(variantId);
    //         }
    //         function getCookie(name) {
    //           const match = document.cookie.match(
    //             new RegExp("(^| )" + name + "=([^;]+)")
    //           );
    //           return match ? decodeURIComponent(match[2]) : null;
    //         }
    //         if ((isSmallBox && cartCount >= 5) || (isLargeBox && cartCount >= 10)) {
    //           // 🔄 localStorage → cookie (same variable name, same logic)
    //           const localVariantId = parseInt(getCookie("selected_variant_id"), 10);

    //           const alreadyInCart = cart.items.some(
    //             (item) => item.variant_id === localVariantId
    //           );

    //           if (localVariantId && !alreadyInCart) {
    //             addItem(localVariantId); // your existing function
    //           }
    //         }

    //         function removeItem(variantId) {
    //             $('body').addClass('free-product-adding');
    //          // $(".progress-bar-container-cart-drawer").addClass("hidden");
    //           $("cart-remove-button.free-gift--product--remove button").trigger(
    //             "click"
    //           );
    //          setTimeout(function () {
    //            $('body').removeClass('free-product-adding');
    //            }, 2000);
    //         }

    //         function addItem(variantId) {

    //           $('body').addClass('free-product-adding');
    //           $.ajax({
    //             url: "/cart/add.js",
    //             type: "POST",
    //             dataType: "json",
    //             data: { id: variantId, quantity: 1 },
    //             success(updatedCart) {
    //               console.log("Free item added ✓");
    //               $.getJSON("/cart.js").done((fullCart) => {
    //                 refreshDrawerAndBubble(fullCart.item_count);
    //               });
    //               //$(".progress-bar-container-cart-drawer").addClass("hidden");
    //               refreshCartDrawer();
    //               $('body').removeClass('free-product-adding');
    //             },
    //             error(xhr) {
    //               console.error(
    //                 "Add to cart failed:",
    //                 xhr.responseText || xhr.statusText
    //               );
    //             },
    //           });
    //         }

    //         function refreshDrawerAndBubble(count) {
    //           $('body').removeClass('free-product-adding');
    //           refreshCartDrawer(); // your custom function
    //           $('.cart-count-bubble span[aria-hidden="true"]').text(count);
    //         }
    //       });

    //       // 1. Function to get cookie value
    // function getCookie(name) {
    //   const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    //   return match ? decodeURIComponent(match[2]) : null;
    // }

    // const freeOfferVariantId = parseInt(getCookie("selected_variant_id"));

    // $.getJSON("/cart.js").done(function (cart) {
    //   let totalCount = 0;

    //   cart.items.forEach(function (item) {

    //     if (item.variant_id === freeOfferVariantId) {
    //       return;
    //     }

    //     totalCount += item.quantity;
    //   });

    //   if (totalCount >= 5) {
    //     $('button#CartDrawer-Checkout').removeAttr('disabled','disabled')
    //   } else {
    //      $('button#CartDrawer-Checkout').attr('disabled','disabled')
    //   }
    // });

    //     }, 2000);
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent("note-update:user-action", event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

  function refreshCartDrawer() {
    let drawerItems = document.querySelector("cart-drawer-items");
    const cartDrawer = document.querySelector("cart-drawer");
    const checkoutBtn = document.querySelector(".cart__checkout-button");

    if (cartDrawer) {
      cartDrawer.classList.remove("is-empty");
      checkoutBtn?.removeAttribute("disabled");

      const emptyEl = cartDrawer.querySelector(".drawer__inner-empty");
      emptyEl?.remove();

      const contentsForm = document.querySelector(".cart__contents");
      if (contentsForm) contentsForm.style.display = "block";
    }

    if (!drawerItems) {
      drawerItems = document.createElement("cart-drawer-items");
      const header = document.querySelector(".drawer__header");
      header?.insertAdjacentElement("afterend", drawerItems);
    }

    const itemsComp = document.querySelector("cart-drawer-items");
    if (typeof itemsComp?.onCartUpdate === "function") {
      itemsComp.onCartUpdate();
    }

    if (typeof cartDrawer?.open === "function") {
      cartDrawer.open();
    }
  }